import { Encrypter, armor } from "age-encryption";

const MONORAIL_PUBLIC_KEY =
  "age15dtl8nkh5xm5gn83u7mhmte3e8xjj77k30xn2y2ymy0ncpmf7yastpssr3";

export const encrypt = async (input) => {
  const e = new Encrypter();
  e.addRecipient(MONORAIL_PUBLIC_KEY);
  const ciphertext = await e.encrypt(input);
  return armor.encode(ciphertext);
};
